export const usererrors = {
  production: false,
 
  Saved_Success_00: "Saved Successfully",
  Update_Success_04: "Updated Succesfully",
  Cancel_Success_00: "Cancelled Succesfully",
  
};